import Utils from '../common/Utils';
import {GLOBAL_PATH, STORE } from '../common/Model';

export default class News {
	constructor(_config) {

		this.config = _config;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'news',
			locale : this.config.locale,
			country : this.config.country
		};
		this.newsApiUrl = GLOBAL_PATH(_option);
		// console.log( '=> news.js this.newsApiUrl : ', this.newsApiUrl);
	}
	init() {
		if( Utils.isEmptyObject(STORE.data.news) ) {
			this.get();
		} else {
			this.render(STORE.data.news);
		}
	}

	get() {
		const _this = this;
		fetch(this.newsApiUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json.list;
			} else {
				_resData = data.list;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.news = _resData;
			_this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
		});
		/*$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${this.newsApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json.list;
			} else {
				_resData = data.list;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.news = _resData;
			this.render(_resData);
		});*/
	}
	render(data) {
		const wrapper = document.querySelector('.news-wrapper');
		const tmpl = this.templ(data);
		if(data && data.length > 0) wrapper.innerHTML = tmpl;
		this.addEvent();
	}
	templ(_d){
		let _option = {
			type: 'url',
			service : this.config.service,
			menu : 'news',
			locale : this.config.locale,
			country : this.config.country
		};
		let _url = GLOBAL_PATH(_option);
		return `
			<a class="news-button" href="${_url}"></a>
				<ul class="news-list">
					${_d.map( (item, index) => {
			return this.listTempl(item);
		}).join('')}
			</ul>`;
	}
	listTempl(_a) {
		return `
			<li class="news-item">
				<a class="news-link" href="${_a.url}" ${_a.target? `target="_blank"`:``}>
					<strong class="news-category">[${_a.category}]</strong>
					<span class="news-title">${_a.title}
					${_a.isNew ? `<span class="icon-new"></span>`:`` }</span>
				</a>
			</li>`;
	}
	addEvent() { // news toggle event
		let parent = document.querySelector('.news-wrapper');
		let button = document.querySelector('.news-wrapper .news-button');
		if (document.querySelectorAll('.news-item').length <= 1) {
			button.style.display = 'none';
		} // 뉴스가 1개 미만이면 토글 버튼 숨김
		let flag;
		button.addEventListener('click', (evt) => {
			evt.preventDefault();
			if(! flag) {
				parent.classList.add('is-active');
				flag = true;
			}else {
				parent.classList.remove('is-active');
				flag = false;
			}
		});
	}
}